module.exports = __webpack_public_path__ + "img/news-2.738a182.png";